<template>
    <div class="modal-window mas013 mas_cal mas_cal_detail">
        <header class="modal-header">
            <div class="tit">
                캘린더
                <div v-if="todoInfo.regUserName" style="float: right;padding-right: 80px;">작성자 : {{ todoInfo.regUserName }}</div>
            </div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>

        <div class="modal-content">
            <ul class="list-table">
                <li>
                    <dl>
                        <dt>할일</dt>
                        <dd>
                            <div class="dropdown relative ty2">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" >{{ paperSelectTitle }}</v-btn>
                                    </template>
                                    <div class="dropdown-list">
                                        <div class="scroll">
                                            <!-- 공통 -->
                                            <div class="dropdown-list-item">
                                                <div class="tit">
                                                    <button type="button" 
                                                    :class="{'active': todoInfo.paperId == ''}" 
                                                    @click="selectPaper()" 
                                                    v-text="paperDefaultTitle"></button>
                                                </div>
                                            </div>
                                            <!-- 보드목록 -->
                                            <div class="dropdown-list-item" v-for="paper in paperList" :value="paper.paperId" :key="paper.paperId">
                                                <div class="tit">
                                                    <button type="button" 
                                                    :class="{'active': todoInfo.paperId == paper.paperId}" 
                                                    @click="selectPaper(paper)" 
                                                    v-text="paper.paperTitle"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-menu>
                            </div>
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>제목</dt>
                        <dd>
                            <div class="input-box">
                                <input v-model="todoInfo.todoTitle" type="text" required placeholder="제목을 입력해주세요.">
                                <button type="reset" class="input-txt-del">입력 삭제</button>
                                <div class="error" v-if="errorCheck.todoTitle">제목을 입력해주세요.</div>
                            </div>
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>장소/위치</dt>
                        <dd>
                            <form action="">
                            <div class="input-box">
                                <input v-model="todoInfo.todoLocation" type="text" required placeholder="장소/위치를 입력해주세요.">
                                <button type="reset" class="input-txt-del">입력 삭제</button>
                            </div>
                            </form>
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>내용</dt>
                        <dd>
                            <div class="textarea-box">
                                <textarea id="count3" v-model="todoInfo.todoContent"></textarea>
                                <div class="error" v-if="errorCheck.todoContent">내용을 입력해주세요.</div>
                            </div>
                            
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>시작시간</dt>
                        <dd>
                            <div class="calendar_box_grp">
                                <div class="calendar_box" style="margin-right:10px">
                                    <datepicker 
                                    v-model="tempStartDate" 
                                    format="yyyy.MM.dd D요일" 
                                    :value="String"
                                    :language="ko"
                                    :disabled-dates="{ from: tempEndDate }"
                                    @input="fnUpdateTodoDate($event,'todoStartDate')"
                                    ></datepicker>
                                </div>

                                <select v-model="tempStartDateHour" class="sel_ty1 txt-01">
                                    <option v-for="hour in hourList"
                                    :value="hour"
                                    :key="hour">{{ hour }}</option>
                                </select>
                                <span style="padding:0 10px 0 10px">:</span>
                                <select v-model="tempStartDateMinute" class="sel_ty1 txt-01">
                                    <option v-for="minute in minuteList"
                                    :value="minute"
                                    :key="minute">{{ minute }}</option>
                                </select>

                                <div class="error" v-if="errorCheck.todoStartDate">시작일을 입력해주세요.</div>
                            </div>
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>종료시간</dt>
                        <dd>
                            <div class="calendar_box_grp">
                                <div class="calendar_box" style="padding-right:10px">
                                    <datepicker 
                                    v-model="tempEndDate" 
                                    format="yyyy.MM.dd D요일" 
                                    :value="String"
                                    :language="ko"
                                    :disabled-dates="{ to: tempStartDate }"
                                    @input="fnUpdateTodoDate($event, 'todoEndDate')"
                                    ></datepicker>
                                </div>
                                
                                <select v-model="tempEndDateHour" class="sel_ty1 txt-01">
                                    <option v-for="hour in hourList"
                                    :value="hour"
                                    :key="hour">{{ hour }}</option>
                                </select>
                                <span style="padding:0 10px 0 10px">:</span>
                                <select v-model="tempEndDateMinute" class="sel_ty1 txt-01">
                                    <option v-for="minute in minuteList"
                                    :value="minute"
                                    :key="minute">{{ minute }}</option>
                                </select>

                                <div class="error" v-if="errorCheck.todoEndDate">종료일을 입력해주세요.</div>
                            </div>
                        </dd>
                    </dl>
                </li>
            </ul>
        </div>

        <footer v-if="modalInfo.todoMainId == null || modalInfo.todoMainId != null && todoInfo.regUserId == userId" class="modal-footer">
            <div class="button-align-cal">
                <div>
                    <button v-if="modalInfo.todoMainId" type="button" class="btn_ty1" @click="fnTodoDelete">삭제</button>
                </div>
                <div>
                    <button v-if="modalInfo.todoMainId" type="button" class="btn_ty1" @click="fnTodoUpdate">수정</button>
                    <button v-else type="button" class="btn_ty1" @click="fnTodoRegister">저장</button>
                    <button type="button" class="btn_ty2" @click="$emit('close')">취소</button>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Datepicker from 'vuejs-datepicker';
import EventBus from "@/js/eventbus/eventBus";
import { ko } from 'vuejs-datepicker/src/locale';

export default {
    components: {
        Datepicker
    },
    props: {
        modalInfo: {
            type: Object,
        },
    },
    data() {
        return {
            date: '2020.12.31',
            error: false,
            paperDefaultTitle: "공통",
            paperSelectTitle: "공통",
            paperList: [],
            todoInfo: {
                todoTitle: "",
                todoStartDate: null,
                todoEndDate: null,
                todoContent: "",
                todoLocation: "",
                paperId: '',
                paperTitle: null,
                regUserId: null,
            },
            linkList: [],
            userInfo: {},
            tempStartDate: null,
            tempEndDate: null,
            tempStartDateHour: "00",
            tempStartDateMinute: "00",
            tempEndDateHour: "00",
            tempEndDateMinute: "00",
            ko: ko,
            hourList: [],
            minuteList: ['00','10','20','30','40','50'],
            errorCheck: {
                todoTitle: false,
                todoContent: false,
                todoStartDate: false,
                todoEndDate: false
            },
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            },
            userId: localStorage.getItem("userId"),
        };
    },
    watch: {
    },
    mounted() {
        this.getBoardAllList();
        this.hourList = [];
        this.tempStartDate = null;
        this.tempEndDate = null;

        for(let i=0; i < 24; i++) {
            this.hourList.push(String(i).padStart(2, '0'));
        }

        if (this.modalInfo.todoMainId) {
            this.getTodoMain();
        } else if (this.modalInfo.selectDate) {
            this.tempStartDate = new Date(this.$moment(this.modalInfo.selectDate));
            this.tempEndDate = this.tempStartDate;

            this.setTodoDatetime();
        }
    },
    methods: {
        ...mapActions("modals", ["showToast", "showModal"]),
        ...mapActions("restAction", ["COWORK_REST_ACTION", "COWORK_REST_SIMPLE_ACTION"]),
        getBoardAllList(){
            let obj = this;
            let param = {
                url: '/api/copaper/paper/getProjectPaperList',
                method: 'post',
                req: {
                    projectId : this.modalInfo.projectId,
                    limitRow: 400,
                    page: 0,
                    sortKey: 'paperTitle',
                    sortDesc: [true],
                }
            };
            obj.COWORK_REST_ACTION(param)
            .then((res) => {
                paperList: [];
                if(res.errorCode == null) {
                    obj.paperList = res.result.paperList.content;
                }
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        selectPaper(paper) {
            if (paper) {
                this.paperSelectTitle = paper.paperTitle;
                this.todoInfo.paperId = paper.paperId;
            } else {
                this.paperSelectTitle = this.paperDefaultTitle;
                this.todoInfo.paperId = '';
            }
        },
        fnTodoRegister() {
            let param = this.todoInfo;
            let successMsg = "일정이 등록되었습니다.";
            let failMsg = "일정 등록이 실패했습니다.";

            this.fnSubmit("/api/copaper/todo/todoInsertFree201", param, successMsg, failMsg);
        },
        fnTodoUpdate() {
            let param = this.todoInfo;
            param.todoMainId = this.modalInfo.todoMainId;
            let successMsg = "일정이 수정되었습니다.";
            let failMsg = "일정 수정이 실패했습니다.";

            this.fnSubmit("/api/copaper/todo/todoUpdateFree201", param, successMsg, failMsg);
        },
        fnTodoDelete() {
            let param = this.todoInfo;
            param.todoMainId = this.modalInfo.todoMainId;
            let successMsg = "일정이 삭제되었습니다.";
            let failMsg = "일정 삭제가 실패했습니다.";

            this.fnSubmit("/api/copaper/todo/todoDeleteFree201", param, successMsg, failMsg);
        },
        fnSubmit(url, param, successMsg, failMsg) {
            let self = this;
            let isErrors = self.checkValidation();

            // projectId 추가
            param.projectId = this.modalInfo.projectId;

            if (!(isErrors.indexOf(true) > -1)) {
                //프로그레스바 시작
                self.showLoadingbar();
                /* 할 일등록 */
                self.$axios
                    .post(url, param)
                    .then((res) => {
                        self.hideLoadingbar();
                        let msg;

                        if (res.data.result != null) {
                            msg = successMsg;
                            EventBus.$emit("refreshTodoMonth");
                            EventBus.$emit("refreshTodoList");
                            self.$emit('close');
                        } else {
                            msg = failMsg;
                        }
                        self.toastInfo.message = msg;
                        self.showToast(self.toastInfo);

                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            }
        },
        setTodoDatetime() {
            // 시간 설정
            this.todoInfo.todoStartDate = this.$moment(this.tempStartDate).format('YYYYMMDD') + this.tempStartDateHour + this.tempStartDateMinute + "00";
            this.todoInfo.todoEndDate = this.$moment(this.tempEndDate).format('YYYYMMDD') + this.tempEndDateHour + this.tempEndDateMinute + "00";
        },
        checkValidation() {
            let isErrors = [];

            isErrors.push(this.checkInput("todoTitle"));
            isErrors.push(this.checkInput("todoContent"));
            isErrors.push(this.checkInput("todoStartDate"));
            isErrors.push(this.checkInput("todoEndDate"));

            this.setTodoDatetime();

            return isErrors;
        },
        checkInput(targetName) {
            let self = this;

            if (self.todoInfo[targetName] && self.todoInfo[targetName].trim().length > 0) {
                self.errorCheck[targetName] = false;
            } else {
                self.errorCheck[targetName] = true;
            }
            return self.errorCheck[targetName];
        },
        fnUpdateTodoDate(event, targetName) {
            this.todoInfo[targetName] = this.$moment(event).format('YYYYMMDD');
        },
        getTodoMain() {
            let obj = this;
            let reqData = {};
            reqData.params = {
                todoMainId: this.modalInfo.todoMainId,
                projectId: this.modalInfo.projectId,
            };
            reqData.req = obj.req;
            reqData.url = "/api/copaper/todo/getTodoMain";
            reqData.method = "post";

            obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
                let res = response.result;
                this.todoInfo = res.todoMain;
                this.tempStartDate = new Date(this.todoInfo.todoStartDate);
                this.tempEndDate = new Date(this.todoInfo.todoEndDate);

                if (this.todoInfo.todoStartDatetime != null && this.todoInfo.todoEndDatetime != null) {
                    let startDatetime = this.$moment(this.todoInfo.todoStartDatetime);
                    this.tempStartDateHour = startDatetime.format('HH');
                    this.tempStartDateMinute = startDatetime.format('mm');

                    let endDatetime = this.$moment(this.todoInfo.todoEndDatetime);
                    this.tempEndDateHour = endDatetime.format('HH');
                    this.tempEndDateMinute = endDatetime.format('mm');
                }
                
                if (this.todoInfo.paperId == '') {
                    this.selectPaper();
                } else {
                    this.selectPaper({ paperId: this.todoInfo.paperId, paperTitle: this.todoInfo.paperTitle });
                }
            });
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/calendar/modal/MAS_Cal_Detail.vue